import React from 'react';
import { BodyText, BoldBodyText, Grid, SideSheet, TinyBodyText } from 'ui-toolkit';
import { eWeekdays, prettyWeekDays } from '../../types/userProfile/IUserProfile';
import { AdminTitle } from '../../components/shared/AdminTitle';
import { IPresentationInternalContact } from '../../types/contacts/IInternalContact';
import { getOffsetName } from '../../utilities/order/getListOfValidTimeZone';
import { getLanguageName } from '../../utilities/getListOfLanguages';
import { useListContactFunctionsQuery } from '../../API/contacts/ContactFunctionsApi';
import { UUID } from '../../types/shared/UUID';
import { useGetAdminUserQuery } from '../../API/administration/AdminUsersAPI';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';

interface IContactProfilePageProps {
  userId: UUID;
  userContactData: IPresentationInternalContact;
  onClose: () => void;
}

export const ContactProfilePage: React.FC<IContactProfilePageProps> = ({ userId, userContactData, onClose }) => {
  const { data: contactFunctions = [] } = useListContactFunctionsQuery();
  const { data: adminUserData, error } = useGetAdminUserQuery(userId);

  return (
    <SideSheet
      title={
        <AdminTitle
          fullName={`${userContactData.firstName} ${userContactData.lastName}`}
          email={userContactData.emailAddress}
        />
      }
      onClose={onClose}
    >
      <ErrorMessageTW rtkError={error} />
      <Grid>
        <TinyBodyText>
          Function
          <BodyText>
            {userContactData.function && contactFunctions?.find((func) => func.id === userContactData.function)?.label}
          </BodyText>
        </TinyBodyText>
        <TinyBodyText>
          Pronouns
          <BodyText>{adminUserData?.pronouns}</BodyText>
        </TinyBodyText>
        <TinyBodyText>
          Location/Time Zone
          <BodyText>{adminUserData?.timeZone && getOffsetName(adminUserData?.timeZone)}</BodyText>
        </TinyBodyText>
        <TinyBodyText>
          Phone Extension
          <BodyText>{adminUserData?.phoneExtension}</BodyText>
        </TinyBodyText>
        <TinyBodyText>
          Work Schedule
          <Grid templateColumns="min-content 1fr" alignItems="center">
            {Object.values(eWeekdays).map((day) => (
              <>
                <BoldBodyText key={day}>{prettyWeekDays[day]}</BoldBodyText>
                <Grid templateColumns="1fr min-content 1fr" alignItems="center">
                  <BodyText>
                    {adminUserData?.workSchedule[day] &&
                      getDateString(DateFormat.smallTime, adminUserData?.workSchedule[day]!.startTime)}
                  </BodyText>
                  to{' '}
                  <BodyText>
                    {adminUserData?.workSchedule[day] &&
                      getDateString(DateFormat.smallTime, adminUserData?.workSchedule[day]!.endTime)}
                  </BodyText>
                </Grid>
              </>
            ))}
          </Grid>
        </TinyBodyText>
        <TinyBodyText>
          Languages
          <BodyText>
            {adminUserData?.languages?.map((lang, index, array) => {
              if (index === array.length - 1) {
                return getLanguageName(lang);
              }
              return getLanguageName(lang) + ', ';
            })}
          </BodyText>
        </TinyBodyText>
        <TinyBodyText>
          Notes
          <BodyText>{adminUserData?.notes}</BodyText>
        </TinyBodyText>
      </Grid>
    </SideSheet>
  );
};
